import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from './services/api.service';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { KeepAwake } from '@capacitor-community/keep-awake';
import { getAuth, indexedDBLocalPersistence, initializeAuth, onAuthStateChanged } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { environment } from 'src/environments/environment';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {

  isCapacitor: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private apiService: ApiService, private alert: AlertController) {
    this.isCapacitor = Capacitor.isNativePlatform();
    if (this.isCapacitor) {
      StatusBar.setStyle({ style: Style.Light });
      KeepAwake.keepAwake();
    }

    const app = initializeApp(environment.firebaseConfig);

    let auth;
    if (Capacitor.isNativePlatform()) {
      auth = initializeAuth(app, {
        persistence: indexedDBLocalPersistence
      })
    } else {
      auth = getAuth()
    }
    // const auth: any = getAuth();

    onAuthStateChanged(auth, (user: any) => {
      if (user) {
        // this.apiService.isLogged = true;
        // this.apiService.isLoggedChanges.next(true);
      } else {
        this.apiService.isLogged = false;
        this.apiService.isLoggedChanges.next(false);
      }
    });
  }

  isLogged: any = false;
  currentUser: any = null;

  ngOnInit() {
    this.isLogged = this.apiService.isLogged;
    this.apiService.isLoggedChanges.subscribe((isLogged: any) => {
      this.isLogged = isLogged
    })

    let main = document.querySelector('#main');
    main?.addEventListener('click', () => {
      if (this.isMenuOpen) {
        this.toggleMenu();
      }
    });

    this.currentUser = this.apiService.currentUser;
    this.apiService.currentUserChanges.subscribe((user: any) => {
      this.currentUser = user;
    });
  }

  goBack(withUpload?: boolean) {
    if (withUpload && this.router.url !== '/home') {
      this.router.navigate(['/home']);
      this.apiService.isUpload = true;
    } else if (!withUpload && this.router.url !== '/home') {
      this.router.navigate(['/home']);
      this.apiService.isUpload = false;
    } else if (withUpload && this.router.url === '/home') {
      this.apiService.isUpload = true;
    } else if (!withUpload && this.router.url === '/home') {
      this.apiService.isUpload = false;
    }

    this.apiService.isUploadChanges.next(this.apiService.isUpload);
  }

  logout() {
    localStorage.removeItem('token');
    this.router.navigate(['/home']);
    window.location.reload();
  }


  isMenuOpen: boolean = false;

  onCoolDown: any = false;

  toggleMenu() {
    let menu = document.querySelector('.split-pane-visible > .split-pane-side');
    let main = document.querySelector('#main');
    let icons = document.querySelectorAll('ion-split-pane ion-menu ion-icon');
    let spans = document.querySelectorAll('ion-split-pane ion-menu span');

    if (this.onCoolDown) {
      return;
    }

    this.onCoolDown = true;
    setTimeout(() => {
      this.onCoolDown = false;
    }, 200);

    if (this.isMenuOpen) {
      this.isMenuOpen = false;
      if (menu && main) {
        spans.forEach((span: any) => {
          span.setAttribute('style', 'cursor: pointer; opacity: 0 !important; position: absolute; left: -9999px;');

        })
        menu.setAttribute('style', 'position: fixed; z-index: 1000; min-width: 55px !important; max-width: 55px !important;');
        setTimeout(() => {
          menu.setAttribute('style', 'min-width: 55px !important; max-width: 55px !important;');
          menu.setAttribute('style', 'position: unset;');
          main.setAttribute('style', 'margin-left: 0px !important;');

          icons.forEach((icon: any) => {
            icon.setAttribute('style', 'margin: auto !important;');
          })

        }, 200);
      }
    } else {
      this.isMenuOpen = true;
      if (menu && main) {
        icons.forEach((icon: any) => {
          icon.setAttribute('style', 'margin: unset !important; margin-left: 12px !important; margin-right: 10px !important;');
        })


        menu.setAttribute('style', 'position: fixed; z-index: 1000; min-width: 220px !important; max-width: 220px !important;');
        main.setAttribute('style', 'margin-left: 55px !important;');

        setTimeout(() => {
          spans.forEach((span: any) => {
            span.setAttribute('style', 'opacity: 1 !important; position: relative; cursor: pointer');
          })
        }, 200);
      }
    }
  }

  deleteAccount() {
    this.alert.create({
      header: 'Supprimer le compte',
      message: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
      cssClass: 'delete-alert',
      buttons: [
        {
          text: 'Annuler',
          role: 'cancel'
        },
        {
          text: 'Supprimer',
          handler: () => {
            this.apiService.deleteAccount(this.currentUser.id).subscribe((res: any) => {
              this.logout();
            });
          }
        }
      ]
    }).then(alert => alert.present());

  }

  register() {
    this.apiService.stepLoginChanges.next(3);
  }
}
